<custom-modal
  modalClass="company-profile-incomplete-modal"
  [open]="isOpen$ | async"
  [header]="'LABELS.COMPANY_PROFILE_INCOMPLETE_MODAL.TITLE'"
  [isListenClose]="true"
  (closeClick)="onOpenChange(false)"
  (openChange)="onOpenChange($event)"
>
  <div class="company-profile-incomplete-modal__text">
    {{ "LABELS.COMPANY_PROFILE_INCOMPLETE_MODAL.TEXT" | translate }}
  </div>
  <div class="company-profile-incomplete-modal__actions" [class.company-profile-incomplete-modal__actions--single]="!isShowGoToProfile">
    <button footer-action type="button" class="btn btn-outline-bordered btn-square" (click)="onOpenChange(false)">
      {{ "BUTTON.CLOSE" | translate }}
    </button>
    <button footer-action type="button" class="btn btn-primary btn-square" *ngIf="isShowGoToProfile" (click)="onGoToProfile()">
      {{ "LABELS.COMPANY_PROFILE_INCOMPLETE_MODAL.CTA" | translate }}
    </button>
  </div>
</custom-modal>
